__webpack_nonce__ = window.webpackNonce;

import React from 'react';
import { createRoot } from 'react-dom/client';

import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

import App from 'Components/App';

const root = createRoot(document.getElementById('app'));

root.render(<App/>);
